import Vue from 'vue';
// Swiper 5 CSS path (works with vue-awesome-swiper@4)
import 'swiper/css/swiper.css'; // if a minor version needs it, use 'swiper/css/swiper.min.css'
const defaultOptionsFactory = () => {
    return {
        // Enable modules via options (no Swiper.use needed on v5 + vue-awesome-swiper@4)
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        autoplay: true,
        loop: true,
        watchOverflow: true,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
        breakpoints: {
            360: { slidesPerView: 1, spaceBetween: 10, slidesPerGroup: 1, loopFillGroupWithBlank: true },
            544: { slidesPerView: 2, spaceBetween: 10, slidesPerGroup: 2, loopFillGroupWithBlank: true },
            768: { slidesPerView: 3, spaceBetween: 10, slidesPerGroup: 3, loopFillGroupWithBlank: true },
            992: { slidesPerView: 3, spaceBetween: 15, slidesPerGroup: 3, loopFillGroupWithBlank: true },
            1200: { slidesPerView: 4, spaceBetween: 15, slidesPerGroup: 4, loopFillGroupWithBlank: true },
        },
    };
};
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
export default Vue.extend({
    name: 'SwiperWrapper',
    components: {
        Swiper,
        SwiperSlide
    },
    props: {
        options: {
            type: Object,
            default: defaultOptionsFactory,
        },
        items: {
            type: Array,
            default: () => [],
        },
        displayPlace: {
            type: String,
            default: 'slider'
        },
        // seconds
        delay: {
            type: Number,
            default: 4,
        },
        showNavigation: {
            type: Boolean,
            default: true,
        },
    },
    // If you registered the plugin globally in main.ts, you don't need local component registration.
    // components: { Swiper, SwiperSlide },
    computed: {
        delayInSeconds() {
            return this.delay * 1000;
        },
    },
});
